module.exports = __webpack_public_path__ + "static/img/case6.0613e68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case6.png
// module id = 5ndn
// module chunks = 3